module.exports = __webpack_public_path__ + "img/plan-image-example.07bfc547.png";